// config4js.js
const ziroProdUrl = 'https://zirostudio.appspot.com';
//const ziroProdUrl = 'https://zirotest-dot-zirostudio.uc.r.appspot.com';
const ziroDevUrl = 'https://ziroaidev.appspot.com';

const prodClientID = '37170801728-5e3di89a5pp1v0rg102a64l0a4so22nu.apps.googleusercontent.com';
const devClientID = '1050770307315-6s4be5midit1kgft5clv237nkpukoc24.apps.googleusercontent.com';
export const globalClientId = prodClientID;
export const serverUrl = ziroProdUrl;
//export const globalClientId = devClientID;
//export const serverUrl = ziroDevUrl;